import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actionLinePicking from '../../../../actions/linePickingAction';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import { Button } from '../../../../components/UI/ComponentsUI';
import ScannerCode from '../../../../components/UI/ScannerCode';
import PickingService from '../../../../services/PickingService';
import { ENUMS } from '../../../../utils/constants';
import { translate, showMessageToastCustom } from '../../../../utils/util';
import * as actionsPicking from '../../../../actions/pickingAction';
import LinePickingService from '../../../../services/LinePickingService';
import InputUI from '../../../../components/UI/InputUI';
import { validateInputsRequired } from '../../../../utils/handleChangeHooks';

const WriteOffList = (props) => {
    const [orderCodeList, setOrderCodeList] = useState([]);
    const [orderCode, setOrderCode] = useState('');
    const [refreshed, setRefreshed] = useState(false);
    const [messages, setMessages] = useState([]);
    let inputFilter;


    useEffect(() => {
        if (inputFilter) {
            inputFilter.focus();
        }
        // eslint-disable-next-line
    }, [inputFilter]);

    const refreshComponent = () => {
        setRefreshed(!refreshed);
    };

    const applyFilter = () => {
        let filter = {};
        filter.orderType = ENUMS.eOrderType.LinePicking.value;
        filter.orderCodeList = orderCodeList;
        props.writeOffOrderList(filter, (response) => {
            setMessages(response);
            setOrderCodeList([]);
            setOrderCode('');
            refreshComponent();
        });


    };

    const subtitlesPickingFilterByOrder = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterByTD') }];
    }

    const scannerBarCode = (code) => {
        setOrderCode(code);
        addOrderCode(code);
        applyFilter();
    }

    const onChangeOrderCode = (code) => {
        setOrderCode(code);
        if (code.length === 12) {
            addOrderCode(code);
        }
    }

    const addOrderCode = (orderCode) => {
        if (validateInputsRequired('orderCodeForm')) {
            let list = [];
            Object.assign(list, orderCodeList);

            if (list.some((element) => element === orderCode)) {
                document.getElementById('orderCode').focus();
                return showMessageToastCustom(translate('warning', 'general'), translate('already-exists', 'general'), 8000, 'mdi mdi-alert-circle-outline red-text');
            }

            list.push(orderCode);
            setOrderCodeList(list);

            document.getElementById('orderCode').value = '';
            document.getElementById('orderCode').focus();
            setOrderCode('');
        }
    };

    const removeOrderCode = (item) => {
        let list = [];
        Object.assign(list, orderCodeList);
        const findIndex = list.indexOf(item)
        list.splice(findIndex, 1);
        setOrderCodeList(list)
        document.getElementById('orderCode').focus();
    }

    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrder" subtitles={subtitlesPickingFilterByOrder()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <form id="orderCodeForm">
                    <div className="row">
                        <div className="input-field no-padding col s10" style={{ marginTop: '10px' }}>
                            <ScannerCode onScanner={scannerBarCode} />
                            <InputUI
                                label="TD"
                                required
                                id="orderCode"
                                name="orderCode"
                                type="text"
                                maxLength="12"
                                value={orderCode || ''}
                                onChange={(event) => onChangeOrderCode(event.target.value)}
                            />
                        </div>
                        <div className="col s1" style={{ paddingTop: '10px' }}>
                            <button
                                className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                type="button"
                                onClick={() => addOrderCode(orderCode)}
                            >
                                <i className={`mdi mdi mdi-plus`} />
                            </button>
                        </div>
                    </div>
                    {orderCodeList && orderCodeList.length > 0 && 
                    <div className="row">
                        <div className="subtitle" style={{ float: 'right',  }}>
                            {translate('truck-kanban:records')} : {orderCodeList.length}
                        </div>
                    </div>}
                    {orderCodeList.length > 0 &&
                        <div className="row" style={{ display: 'flex', flexDirection: 'column', flex: 1, flexWrap: 'wrap', flexFlow: 'column wrap' }}>
                            {orderCodeList?.map((i, index) => (
                                <div key={index} style={{ display: 'flex', flex: 1, alignItems: 'center', padding: 4, margin: 2, border: 'solid', borderWidth: 1, width: 'auto', borderRadius: 6 }}>
                                    <i className={'mdi mdi-close-circle-outline posfix'} style={{ top: '0rem', fontSize: 20 }} onClick={() => removeOrderCode(i)} />
                                    <span style={{ marginLeft: 6 }}>{i}</span>
                                </div>
                            ))}
                        </div>
                    }
                </form>
                <div className="row">
                    <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                    <Button onClick={() => applyFilter()} text={translate('confirm', 'general')} />
                </div>
                {messages.length > 0 &&
                    <div id="messages" style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                        {messages.map((item, index) => (
                            <span className={item.success ? "success-color" : "fourth-text-color"} key={index}> • {item.message} </span>
                        ))}
                    </div>

                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(actionLinePicking.setFilter(filter));
        },
        getOrders: (filter, pagination, callback) => {
            dispatch(LinePickingService.getOrders(filter, pagination, callback));
        },
        setFilterOrderItem: (filter) => {
            dispatch(actionsPicking.setFilter(filter));
        },
        writeOffOrderList: (orderCode, callback) => {
            dispatch(PickingService.writeOffOrderList(orderCode, callback));
        },
        setSelectedMission: (mission) => {
            dispatch(actionLinePicking.selectMission(mission));
        },
        updateMissionStatus: (orderItemId, status) => {
            dispatch(actionLinePicking.updateMissionStatus(orderItemId, status));
        },
        startOrder: (orderId, callback) => {
            dispatch(LinePickingService.startOrder(orderId, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LinePickingService.startOrderItem(orderId, orderItemId, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WriteOffList)));